export const apiReferenceHref = '/docs/index.html';
export const documentationHref = 'https://exceptionless.com/docs/';
export const githubRepositoryHref = 'https://github.com/exceptionless/Exceptionless';
export const supportIssuesHref = `${githubRepositoryHref}/issues`;
